// Copyright 2020 Sorama B.V.

import { PLATFORM } from "aurelia-framework";
import { CanvasMediaObjectLinkDTO, FileDTO, LinkedMediaObjectType } from "datatypes/SoramaWebApi";
import { FileDownloader } from "libraries/FileDownloader/FileDownloader";
import { ICanvasMediaObjectLinkRepository } from "repositories/CanvasMediaObjectLinkRepository";
import { ILinkedMediaObjectRepository } from "repositories/LinkedMediaObjectRepository";
import { BoundingBox, IComposableParent } from "./../ComposableCanvas";
import { ComposableContentType, ComposableMediaObject, IComposableMediaObjectAction } from "./ComposableMediaObject";

export class ComposableFileMediaObject extends ComposableMediaObject {
    public get mediaObjectType(): LinkedMediaObjectType {
        return LinkedMediaObjectType.File;
    }

    public readonly additionalActions: IComposableMediaObjectAction[] = [
        { icon: "fas fa-download", action: () => this.downloadFile() },
    ];

    public readonly template: string = PLATFORM.moduleName("controls/composable-canvas/templates/FileTemplate.html");
    public readonly preserveAspectRatio: boolean = true;
    public readonly contentType: ComposableContentType = ComposableContentType.scaled;

    protected source: FileDTO;

    constructor(
        private readonly linkRepository: ICanvasMediaObjectLinkRepository,
        parent: IComposableParent,
        link: CanvasMediaObjectLinkDTO,
        initialSize: BoundingBox,
        fileLinkedMediaObject: FileDTO,
        private readonly linkedMediaObjectRepository: ILinkedMediaObjectRepository
    ) {
        super(linkRepository, parent, link, initialSize);

        this.source = fileLinkedMediaObject;
    }

    public downloadFile(): Promise<void> {
        return this.linkedMediaObjectRepository.getData(this.source.id).then((blob) => {
            FileDownloader.downloadBlobAsFile(blob, this.source.mimeType, this.source.name);
        });
    }
}
